var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 25,
  viewBox: "0 0 19 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "always-recording",
  transform: "translate(3081 3876)"
}, /*#__PURE__*/React.createElement("g", {
  id: "f2e99137666f4b94611763915e6ffa5e",
  transform: "translate(-3085 -3868)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44174",
  "data-name": "Path 44174",
  d: "M11.786,4.5a.678.678,0,0,0,.857.5.691.691,0,0,0,.571-.857A2.775,2.775,0,0,0,10.429,2H6.857A2.866,2.866,0,0,0,4,4.857v7.286a.675.675,0,0,0,.714.714.675.675,0,0,0,.714-.714V4.857A1.433,1.433,0,0,1,6.857,3.429h3.571A1.376,1.376,0,0,1,11.786,4.5Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44175",
  "data-name": "Path 44175",
  d: "M6.167,5.714v.714a.679.679,0,0,0,.722.714.679.679,0,0,0,.722-.714V5.714A.679.679,0,0,0,6.889,5,.679.679,0,0,0,6.167,5.714Zm2.167,0v.714a.722.722,0,0,0,1.444,0V5.714a.722.722,0,0,0-1.444,0Zm7.439-.5-2.528,2.5L5.3,15.571,4.217,16.643a.685.685,0,0,0,0,1,.7.7,0,0,0,1.011,0l.722-.714a2.017,2.017,0,0,0,.939.214h5.778a2.882,2.882,0,0,0,2.889-2.857v-5a.645.645,0,0,0-.217-.5l-.578-.571,2.022-2a.685.685,0,0,0,0-1,.7.7,0,0,0-1.011,0ZM14.111,9.571v4.714a1.441,1.441,0,0,1-1.444,1.429H7.178l6.572-6.5Z",
  transform: "translate(0 -0.857)"
})), /*#__PURE__*/React.createElement("g", {
  id: "ac70e98c49c3369f2b36278293a9f677",
  transform: "translate(-3060 -3882) rotate(90)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44151",
  "data-name": "Path 44151",
  d: "M8.667,16h2.667A2.744,2.744,0,0,0,14,13.2V6.9a2.651,2.651,0,0,0-1.333-2.38V4.1a2.015,2.015,0,0,0-2-2.1H9.333a2.015,2.015,0,0,0-2,2.1v.42A2.734,2.734,0,0,0,6,6.9v6.3A2.744,2.744,0,0,0,8.667,16ZM9.333,3.4h1.333a.646.646,0,0,1,.667.7H8.667A.646.646,0,0,1,9.333,3.4Zm-2,3.5A1.372,1.372,0,0,1,8.667,5.5h2.667a1.372,1.372,0,0,1,1.333,1.4v6.3a1.372,1.372,0,0,1-1.333,1.4H8.667a1.372,1.372,0,0,1-1.333-1.4Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20777",
  "data-name": "Rectangle 20777",
  width: 4,
  height: 2,
  rx: 1,
  transform: "translate(8 12)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20778",
  "data-name": "Rectangle 20778",
  width: 4,
  height: 2,
  rx: 1,
  transform: "translate(8 9)"
})))));

export default __webpack_public_path__ + "static/media/always-recording.d78b8d5e.svg";
export { SvgComponent as ReactComponent };